// libraries
import doubleClickZoom from '@/vue3/mapbox/lib/doubleClickZoom.js';

// methods
const DrawRectangleMode: any = {
    // When the mode starts this function will be called.
    onSetup: function (opts): any {
        let state: any = {};
        if (opts.selectedFeature && opts.selectedFeature.id) {
            opts.selectedFeature = this._ctx.api.get(opts.selectedFeature.id);
        }
        state.selectedFeature = opts.selectedFeature || false;
        doubleClickZoom.disable(this);
        return state;
    },

    // Whenever a user clicks on the map, Draw will call `onClick`
    onClick: function (state, e) {
        // if state.startPoint exist, means its second click
        //change to  simple_select mode
        if (
            state.startPoint &&
            state.startPoint[0] !== e.lngLat.lng &&
            state.startPoint[1] !== e.lngLat.lat
        ) {
            state.endPoint = [e.lngLat.lng, e.lngLat.lat];
            state.startPoint = false;
            return;
        }

        // on first click, save clicked point coords as starting for  rectangle
        const startPoint = [e.lngLat.lng, e.lngLat.lat];
        state.startPoint = startPoint;
    },

    onMouseMove: function (state, e): any {
        if (state.startPoint) {
            state.selectedFeature.geometry.coordinates = [
                [
                    [e.lngLat.lng, state.startPoint[1]],
                    [state.startPoint[0], state.startPoint[1]],
                    [state.startPoint[0], e.lngLat.lat],
                    [e.lngLat.lng, e.lngLat.lat],
                    [e.lngLat.lng, state.startPoint[1]],
                ],
            ];
            this._ctx.api.add(state.selectedFeature);
        }
    },

    onStop: function (state) {
        doubleClickZoom.enable(this);
    },

    toDisplayFeatures: function (state, geojson, display) {
        const isActivePolygon =
            geojson.properties.id === state.selectedFeature.id;
        geojson.properties.active = isActivePolygon ? 'true' : 'false';
        if (!isActivePolygon) return display(geojson);

        // Only render the rectangular polygon if it has the starting point
        if (!state.startPoint) return;
        return display(geojson);
    },
};

export default DrawRectangleMode;
